import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { Object3D } from "./Viewer.Object3D.js";

const _axis = /*@__PURE__*/ new THREE.Vector3();

class ForceHelper extends Object3D {
    constructor( components = [0, 0, 1], labelText, lineMaterial, meshMaterial, color ) {

        super();

        this.type = 'ForceHelper';

        this.components = new THREE.Vector3(...components);
        this.dir = this.components.clone().normalize().multiplyScalar( -1 );
        this.magnitude = this.components.length();

        // line
        const lineGeometry = new THREE.BufferGeometry();
        lineGeometry.setAttribute( 'position', new THREE.Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

        // cone
        const coneGeometry = new THREE.CylinderGeometry( 0.5, 0, 1, 7, 1 );
        coneGeometry.translate( 0, 0.5, 0 );

        this.position.copy( new THREE.Vector3() );

        this.line = new THREE.Line( lineGeometry, lineMaterial );
        this.line.matrixAutoUpdate = false;
        this.add( this.line );

        this.cone = new THREE.Mesh( coneGeometry, meshMaterial );
        this.cone.matrixAutoUpdate = false;
        this.add( this.cone );

        this.div = this.createLabelElement(labelText);
        this.label = new CSS2DObject(this.div);
        this.add( this.label );

        this.setDirection( this.dir );
        this.setScale( 1 );
        this.setColor( color );
    }

    setDirection( dir ) {
        // dir is assumed to be normalized

        if ( dir.y > 0.99999 ) {

            this.quaternion.set( 0, 0, 0, 1 );

        } else if ( dir.y < - 0.99999 ) {

            this.quaternion.set( 1, 0, 0, 0 );

        } else {

            _axis.set( dir.z, 0, - dir.x ).normalize();

            const radians = Math.acos( dir.y );

            this.quaternion.setFromAxisAngle( _axis, radians );

        }

    }

    setScale( scaleFactor ) {
        const length = this.magnitude * scaleFactor;
        const headLength = 0.25 * length;
        const headWidth = 0.15 * length;

        this.line.scale.set( 1, Math.max( 0.0001, length ), 1 ); // see #17458
        this.line.updateMatrix();

        this.cone.scale.set( headWidth, headLength, headWidth );
        this.cone.updateMatrix();

        this.updateLabelPosition();

    }

    setColor( color ) {

        this.line.material.color.set( color );
        this.cone.material.color.set( color );
        this.div.style.color = color;

    }

    copy( source ) {

        super.copy( source, false );

        this.line.copy( source.line );
        this.cone.copy( source.cone );

        return this;

    }

    createLabelElement( text ) {
        const div = document.createElement('div');

        div.className = 'force-label';
        div.textContent = text;
        div.style.marginTop = '-1em';
        div.style.padding = '2px 4px';
        div.style.borderRadius = '4px';
        div.style.fontSize = '12px';

        return div;
    }

    updateLabelPosition() {
        if (this.label) {
            this.label.position.set(0, this.line.scale.y, 0);
        }
    }

}


export { ForceHelper };